import { ReactElement } from 'react'
import { StyledSkeleton } from './styles'
import { SkeletonProps } from './props'

const Skeleton = (props: SkeletonProps): ReactElement => {
    switch (props.variant) {
        case 'circle':
        case 'rectangle':
            return (
                <StyledSkeleton
                    css={{ h: props.height, w: props.width }}
                    variant={props.variant}
                />
            )
        default:
            return <StyledSkeleton css={{ w: props.width ?? '100%' }} />
    }
}

export default Skeleton

export { StyledSkeleton }
